import { Box } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { reset } from '../../stores/DevicesReportStore';

import usePortalConfig from '../../hooks/usePortalConfig/usePortalConfig';
import useRolePermissions from '../../hooks/useRolePermissions/useRolePermissions';

import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import PageTitle from '../../components/Text/PageTitle';
import Button from '../../components/Button/Button';
import PlusIcon from '../../components/Icons/PlusIcon';
import DevicesReportTable from './DevicesReportTable';
import AddDeviceDrawer from '../ESimManager/UserDetails/components/AddDeviceDrawer/AddDeviceDrawer';

interface DevicesReportProps {
  unassignedReport?: boolean;
}

function DevicesReport({ unassignedReport = false }: DevicesReportProps) {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const { isUserAllowed } = useRolePermissions();
  const { routePermissions } = usePortalConfig();
  const [showAddDevice, setShowAddDevice] = useState(false);
  const [key, setKey] = useState(0);

  React.useEffect(() => {
    dispatch(reset());
  }, []);

  return (
    <Box>
      <Breadcrumbs
        activeLinks={[{ label: t('navbar.dashboard'), url: `/dashboard` }]}
        disabledLinks={[!unassignedReport ? t('pages.devicesReport.title') : t('pages.devicesReport.unassignedTitle')]}
      />
      <Box sx={{ display: 'flex', alignItems: 'center', paddingTop: '0' }}>
        <PageTitle>
          {!unassignedReport ? t('pages.devicesReport.title') : t('pages.devicesReport.unassignedTitle')}
        </PageTitle>
        <Box sx={{ display: 'flex', marginLeft: 'auto' }}>
          {unassignedReport && isUserAllowed(routePermissions.devicesCreate) ? (
            <>
              <Button
                onClick={() => {
                  setShowAddDevice(true);
                }}
                label={
                  <>
                    <Box sx={{ marginRight: '0.5rem' }}>
                      <PlusIcon />
                    </Box>
                    {t('pages.addDeviceDrawer.button')}
                  </>
                }
              />
              <AddDeviceDrawer
                onClose={() => {
                  setShowAddDevice(false);
                }}
                open={showAddDevice}
                onAddDeviceSuccess={() => {
                  setKey((prevKey) => prevKey + 1);
                }}
                unassignedReport={unassignedReport}
              />
            </>
          ) : null}
        </Box>
      </Box>
      <DevicesReportTable key={key} unassignedReport={unassignedReport} />
    </Box>
  );
}

export default DevicesReport;
